<template>
  <main-dialog />
</template>

<script>
import vuetify from "./plugins/vuetify.js";
import MainDialog from "./components/MainDialog.vue";
import eventsManager from "./modules/eventsManager.js";

export default {
  name: "App",
  vuetify,
  components: {
    MainDialog,
  },
  props: [
    "contentId",
    "contentTitle",
    "contentLede",
    "contentPriceInCents",
    "contentUrl",
    "publisherId",
    "apiKey",
    "publisherName",
    "publisherLogoSrc",
    "contentThumbnail",
    "primaryColor",
    "accentColor",
  ],
  watch: {
    contentId: function (newVal, oldVal) {
      eventsManager.trigger("passepartout-widget:new-content-loaded", {
        oldContentId: oldVal,
        newContentId: newVal,
      });
    },
  },
  mounted() {
    if (this.primaryColor) {
      this.$vuetify.theme.themes.light.primary = this.primaryColor;
    }
    if (this.accentColor) {
      this.$vuetify.theme.themes.light.accent = this.accentColor;
    }
    this.$store.state.contentId = this.contentId;
    this.$store.state.contentTitle = this.contentTitle;
    this.$store.state.contentLede = this.contentLede;
    this.$store.state.contentPriceInCents = this.contentPriceInCents;
    this.$store.state.contentUrl = this.contentUrl;
    this.$store.state.contentThumbnail = this.contentThumbnail;
    this.$store.state.publisherId = this.publisherId;
    this.$store.state.publisher.apiKey = this.apiKey; // only used if check access right is made front-end side.
    this.$store.state.publisher.name = this.publisherName;
    this.$store.state.publisher.logoUrl = this.publisherLogoSrc;

    // The widget must always be opened after the basic page info have been logged in the store.
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    if (
      urlParams &&
      urlParams.has("openWidget") &&
      urlParams.get("openWidget").toLowerCase() === "true"
    ) {
      this.$store.dispatch("openDialog");
    }
    if (urlParams && urlParams.has("transactionId")) {
      this.$store.dispatch("checkForPayinError", urlParams.get("transactionId"));
    }
  },
};
</script>

<style src="vuetify/dist/vuetify.css"></style>

<style>
.v-btn.v-size--x-small {
  font-size: 0.625em;
}

.v-btn.v-size--small {
  font-size: 0.75em;
}

.v-btn.v-size--default {
  font-size: 0.875em;
}

.v-btn.v-size--large {
  font-size: 0.875em;
}

.v-btn.v-size--x-large {
  font-size: 1em;
}

.v-card__text {
  font-size: 0.875em;
  font-weight: 400;
  line-height: 1.375em;
  letter-spacing: 0.0071428571em;
}

.v-card__title {
  font-size: 1.25em;
  letter-spacing: 0.0125em;
  line-height: 2em;
}

.v-application .text-body-1 {
  font-size: 1em !important;
  line-height: 1.5em;
}
.v-application .text-body-1 {
  font-size: 0.875em !important;
  line-height: 1.25em;
}

.v-application .body-1 {
  font-size: 1em !important;
  letter-spacing: 0.03125em;
}

.v-application .body-2 {
  font-size: 0.875em !important;
  letter-spacing: 0.0178571429em!important;
}

.v-application .text-caption {
  font-size: 0.75em !important;
  line-height: 1.25em;
}

.v-application .text-h6 {
    font-size: 1.25em !important;
    line-height: 2em;
    letter-spacing: 0.0125em !important;
}

v-list-item--dense .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle {
    font-size: 0.8125em;
    line-height: 1em;
}

.v-list--dense .v-subheader {
    font-size: 0.75em;
}

.v-card__actions > .v-btn.v-btn {
  padding: 0;
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  /* to remove the default 8px */
  margin-left: 0px;
}

.primary-btn {
  background-color: var(--v-primary-base) !important;
  color: var(--v-accent-lighten3) !important;
}
</style>
